import { IInitialState } from 'store/models';
import { moduleStateSelector } from './moduleStateSelector';

export function respondentDataSelector(state: IInitialState) {
	return moduleStateSelector(state).respondentData;
}
